import PasswordPage from './PasswordPage';
import PasswordPageContainer from './PasswordPage.container';

export default PasswordPageContainer(PasswordPage);
